@let smallScreenOppening = smallScreen$ | async;
@let mediumScreenOppening = mediumScreen$ | async;
@let largeScreenOppening = largeScreen$ | async;

<div id="opening-step" #openingStep [ngClass]="{smallScreenOppening, mediumScreenOppening, largeScreenOppening}">
    <h1>{{ 'landing_page.step_1.hook' | translate }}</h1>
    <h2>{{ 'landing_page.step_1.baseline' | translate }}</h2>
    <app-button magicHover type="get-started" (click)="getStartedClick.emit()">{{ 'common.get_started' | translate
        }}</app-button>
    <lucide-angular size="32" name="arrowDown" (click)="arrowClick.emit()"></lucide-angular>

    <div class="noise"></div>
    <div #circle class="circle"></div>
    <div class="gradient"></div>
</div>